import React from 'react'
import { Modal } from 'antd'
import { toggleImportModelModal } from '../../../../../../../store/slices/assignment.slice'
import { useDispatch } from 'react-redux'
import ImportModelForm from './ImportModelForm'

const ImportModelModal = () => {
    const dispatch = useDispatch()
    return (
        <Modal title='Import Model' open={true} footer={null} onCancel={() => dispatch(toggleImportModelModal())} data-test="import-modal">
            <ImportModelForm onCancel={() => dispatch(toggleImportModelModal())} />
        </Modal>
    )
}

export default ImportModelModal
